import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Proovi sõnadeta otsingut ja leia ideaalne mööbel kiiremini. Lihtsalt klõpsa <span style="color:#a6d189;">**{mirosIcon}**</span> toote juures ja leia

  <span style="color:#85c1dc;">**FI:**</span>
  Kokeile etsimistä ilman sanoja ja löydä haluamasi kaluste nopeammin. Klikkaa <span style="color:#a6d189;">**{mirosIcon}**</span>

  <span style="color:#85c1dc;">**RU:**</span>
  Попробуй бессловесный поиск и быстрее найди идеальную мебель. Просто нажми <span style="color:#a6d189;">**{mirosIcon}**</span> и найди
*/
/* @__NO_SIDE_EFFECTS__ */
const m121 = msg(
  mf`Proovi sõnadeta otsingut ja leia ideaalne mööbel kiiremini. Lihtsalt klõpsa ${'mirosIcon'} toote juures ja leia`,
  mf`Kokeile etsimistä ilman sanoja ja löydä haluamasi kaluste nopeammin. Klikkaa ${'mirosIcon'}`,
  mf`Попробуй бессловесный поиск и быстрее найди идеальную мебель. Просто нажми ${'mirosIcon'} и найди`,
)

export { m121 as 'w.module.try_new_search.text' }